<div class="row">
  <div class="col-md-8">
    <div class="border-checkbox-section">
      <div class="border-checkbox-group border-checkbox-group-primary">
        <input type="checkbox" class="border-checkbox" [id]="Index+'emailconfirm'" [(ngModel)]="solution.solutionSteps[Index].actionEmail.requiredConfirm" (ngModelChange)="updateSolution()" name="requiredConfirm"  #requiredConfirm="ngModel">
        <label [for]="Index+'emailconfirm'" class="border-checkbox-label">{{'admin.action_email.edit_email_before_send'|translate}}</label>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-8">
    <div class="mb-2"><strong>{{'admin.emails.manage.body_information'|translate}} </strong></div>
    <nav ngbNav #nav="ngbNav" class="nav nav-tabs">
      <div ngbNavItem *ngFor="let tab of tabs;let i=index">
        <a ngbNavLink class="nav-link">{{tab.title}}</a>
        <ng-template ngbNavContent>
          <div [@fadeInOutTranslate] class="m-t-15">
            <quill-editor [modules]="modules"  (onContentChanged)="updateEmailBody()" [name]="Index+'email'+i" [(ngModel)]="solution.solutionSteps[Index].actionEmail[tab.mapping]" (ngModelChange)="updateSolution()" ></quill-editor>
          </div>
        </ng-template>
      </div>
    </nav>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
    <div class="row token-header mx-0 ms-0">
      <div class="col-md-6">{{'admin.general_items.name' | translate}}</div>
      <div class="col-md-6">{{'global.token' | translate}}</div>
    </div>
    <div *ngFor="let token of tokens; let i = index" class="row mx-0 ms-0">
      <div class="col-md-6">{{token.description}}</div>
      <div class="col-md-6 cursor-pointer" [copy-clipboard]="token.name" (copied)="clipboardUpdated()"
          ngbTooltip="{{'admin.emails.manage.click_to_copy' | translate}}" placement="left">{{token.name}}
      </div>
    </div>
  </div>
  <div class="col-md-4" style="padding-right:0">
    <div class="mt-4">
      <div class="box box-default min-margin">
        <div class="box-body">
          <div class="form-group">
            <div class="manage-title">
              <ng-container *ngIf="!iframeUrl">{{'admin.emails.manage.email_preview_loading'|translate}}
              </ng-container>
              <iframe *ngIf="iframeUrl" [src]="iframeUrl" width="100%" height='450px'
                      class="email-preview" style="border:1px solid lightgray; padding: 0 10px"></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>